import { TrackPayload, UserIdentifier } from "../types";

export const ANALYTICS = "ANALYTICS";
export const STORE_USER_IDENTIFIER_FOR_ANALYTICS =
  "IDENTIFY_USER_FOR_ANALYTICS";

export const Track = (payload: TrackPayload) => ({
  type: ANALYTICS,
  payload,
});

export const StoreUserIdentifier = (payload: UserIdentifier) => ({
  type: STORE_USER_IDENTIFIER_FOR_ANALYTICS,
  payload,
});
